// ANGULAR
import { inject, Injectable } from '@angular/core';

// SERVICES
import { WorkOrderAsyncService } from 'src/app/app-services-async/work-order-async.service';
import { DataModelHelperService } from 'src/app/app-services-helper/data-model-helper.service';
import { ErrorHandlerService } from 'src/app/app-services-async/w-h-error-handler.service';

// REDUX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  WHWorkOrderMasterDataStoreActionTypes,
  GetWHWorkOrderDtoList,
  SetWHWorkOrderDomList,
  UpdateWorkOrderSortPosition,
} from './w-h-work-order-master-data-store.actions';

// RxJS 6
import { of } from 'rxjs';
import { switchMap, mergeMap, concatMap, map, catchError } from 'rxjs/operators';

// MODELS
import { IWHWorkOrderDTO, WHWorkOrderDOM } from '@workheld/workheld-shared-lib';

@Injectable()
export class WHWorkOrderMasterDataStoreEffects {
  private actions$ = inject(Actions);
  private workOrderAsyncService = inject(WorkOrderAsyncService);
  private dataModelHelperService = inject(DataModelHelperService);

  getWHWorkOrderDtoList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WHWorkOrderMasterDataStoreActionTypes.GetWHWorkOrderDtoList),
      switchMap((action: GetWHWorkOrderDtoList) => {
        return this.workOrderAsyncService.getWorkOrderDtoList(
          action.payload.workObjectTypeId,
          action.payload.workObjectId,
          action.payload.withTargetTimes,
        );
      }),
      mergeMap((workOrders: IWHWorkOrderDTO[]) => {
        let workOrderDomList: WHWorkOrderDOM[] = [];
        (workOrders as Array<IWHWorkOrderDTO>).forEach(
          (workOrderDTO: IWHWorkOrderDTO) => {
            workOrderDomList.push(
              this.dataModelHelperService.initWorkOrderDOM(workOrderDTO),
            );
          },
        );
        workOrderDomList = workOrderDomList.sort(
          (a: WHWorkOrderDOM, b: WHWorkOrderDOM) => {
            if (a.sortPosition < b.sortPosition) {
              return -1;
            }
            if (a.sortPosition > b.sortPosition) {
              return 1;
            }
            return 0;
          },
        );
        return [
          new SetWHWorkOrderDomList({
            workOrderDomList,
            loading: false,
            loaded: true,
          }),
        ];
      }),
    );
  });

  updateWorkOrderSortPosition$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WHWorkOrderMasterDataStoreActionTypes.UpdateWorkOrderSortPosition),
      concatMap((action: UpdateWorkOrderSortPosition) => {
        const { workOrderId, sortPosition, workOrderDomList, previousWorkOrderDomList } =
          action.payload;
        return this.workOrderAsyncService
          .updateWorkOrderSortPosition(workOrderId, sortPosition)
          .pipe(
            // 204: backend applied the same order, keep the local one
            map(
              () =>
                new SetWHWorkOrderDomList({
                  workOrderDomList,
                  loading: false,
                  loaded: true,
                }),
            ),
            catchError((error) => {
              ErrorHandlerService.handleGlobalError(error);
              return of(
                new SetWHWorkOrderDomList({
                  workOrderDomList: previousWorkOrderDomList,
                  loading: false,
                  loaded: true,
                }),
              );
            }),
          );
      }),
    );
  });
}
